import React from 'react'
import styled from 'styled-components'
import { colors } from '../../../../colors'
import { VscMenu } from 'react-icons/vsc'

const Header = () => {
  return (
    <Container>
        
        <img src={'https://via.placeholder.com/150'} alt={'logo'} />
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: flex-end;
    /* background-color: ${colors.primary}; */
    padding: 10px .5rem;
    width: 100%;

    img {
        width: 40px;
        border-radius: 50%;
    }


`

export {Header}